import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, OneToMany, ManyToOne, JoinColumn,
} from 'typeorm';
import { IsOptional, IsInt, IsDate } from 'class-validator';
import { Consulta } from './Consulta';
import { Usuario } from './Usuario';

@Entity({name: "consultas_coletivas"})
export class ConsultaColetiva {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  @IsOptional()
  observacoes?: string | null;

  @Column()
  @IsDate()
  datetime_agendamento: Date;

  @Column()
  @IsDate()
  datetime_agendamento_fim: Date;

  @Column()
  @IsOptional()
  datetime_cancelamento?: Date | null;

  @Column()
  @IsOptional()
  justificativa_cancelamento?: string | null;

  @Column()
  @IsOptional()
  started?: Date | null;

  @Column()
  @IsOptional()
  started_by?: number | null;

  @Column()
  @IsOptional()
  ended?: Date | null;

  @Column()
  @IsOptional()
  ended_by?: number | null;

  @CreateDateColumn()
  @IsOptional()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  @IsOptional()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @OneToMany(type => Consulta, consultas => consultas.consulta_coletiva, {
    eager: true,
    cascade: ['insert', 'update'],
  })
  consultas?: Consulta[];

  @ManyToOne(type => Usuario, { eager: true })
  @JoinColumn({ name: "created_by" })
  usuario_created_by?: Usuario;

  // vai ser o usuario que cancelou se estiver cancelada
  @ManyToOne(type => Usuario, { eager: true })
  @JoinColumn({ name: "updated_by" })
  usuario_updated_by?: Usuario;

  @ManyToOne(type => Usuario, { eager: true })
  @JoinColumn({ name: "started_by" })
  usuario_started_by?: Usuario;

  @ManyToOne(type => Usuario, { eager: true })
  @JoinColumn({ name: "ended_by" })
  usuario_ended_by?: Usuario;
}
